import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const ArrowBottomIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M11.9999 13.071L8.17891 9.24995C7.76491 8.83595 7.09291 8.83595 6.67891 9.24995C6.26491 9.66395 6.26491 10.336 6.67891 10.75L11.2929 15.364C11.6839 15.755 12.3169 15.755 12.7069 15.364L17.3209 10.75C17.7349 10.336 17.7349 9.66395 17.3209 9.24995C16.9069 8.83595 16.2349 8.83595 15.8209 9.24995L11.9999 13.071Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

ArrowBottomIcon.propTypes = {
  sx: PropTypes.object,
};

export default ArrowBottomIcon;
